import { Component, OnInit } from "@angular/core";
import { BaseListDirective } from "../../../util/directives/base-list.directive";
import { EntityTyp } from "../../../util/enums/entity-typ.enum";
import { ContentHeader } from "../../../layout/components/content-header/content-header.component";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalService } from "../../../util/service/modal.service";
import { FormBuilder } from "@angular/forms";
import Swal from "sweetalert2";
import { colors } from "../../../colors.const";
import { HousingListItemDto, OfficeNameDto } from "app/api/models";
import { HousingService } from "app/api/services";
import { AuthService } from "../../../util/service/auth.service";
import { UserRole } from "app/server/enums/user-role.enum";
import { CaslAction } from "../../../server/enums/casl-action.enum";
import { ToastrService } from "ngx-toastr";

@Component({
    selector: "app-housing-list",
    templateUrl: "./housing-list.component.html",
    styleUrl: "./housing-list.component.scss",
    standalone: false
})
export class HousingListComponent extends BaseListDirective<HousingListItemDto> implements OnInit {
  override modalType = EntityTyp.Housing;
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;

  protected readonly UserRole = UserRole;

  public contentHeader: ContentHeader;

  offices: OfficeNameDto[];

  constructor(
    protected override route: ActivatedRoute,
    protected override router: Router,
    private housingService: HousingService,
    protected override modalService: ModalService,
    protected override fb: FormBuilder,
    public authService: AuthService,
    private toastrService: ToastrService
  ) {
    super(fb, route, router, modalService);
  }

  ngOnInit(): void {
    this.offices = this.route.snapshot.data["offices"];

    this.contentHeader = {
      headerTitle: "Wohnungen",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Startseite",
            isLink: true,
            link: "/",
            translate: "MENU.HOME",
          },
          {
            name: "Wohnungen",
            isLink: false,
            translate: "MENU.HOUSING",
          },
        ],
      },
    };

    this.initFilter({
      name: [null],
      address: [null],
      officeId: [null],
    });
  }

  reload() {
    this.housingService.housingControllerFindAll(this.filter.value).subscribe({
      next: (page) => {
        this.page = page;
        this.syncPageNumber();
      },
    });
  }

  async openModal(id?: number) {
    await this.modalService.openEntityModal(EntityTyp.Housing, id);
    this.reload();
  }

  async delete(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diese Wohnung wirklich löschen?",
      icon: "error",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.danger,
      confirmButtonText: "Löschen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.housingService.housingControllerDelete({ id }).subscribe((res) => {
        this.reload();
      });
    }
  }

  async restore(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diese Wohnung wirklich wiederherstellen?",
      icon: "question",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.info,
      confirmButtonText: "Wiederherstellen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.housingService.housingControllerRestore({ id }).subscribe((res) => {
        this.toastrService.success("Erfolgreich wiederhergestellt", "Erfolgreich wiederhergestellt");
        this.reload();
      });
    }
  }
}
